import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { InfoTooltip } from '@components/main-components/tooltip/InfoTooltip';
import { LEARN_MORE_ABOUT_SAM, SPACE } from '@utils/constants';
import { SOUND_MARKET_PLACE_URL } from '@utils/constants';

export const SoundSwapMintedInfo = () => {
  return (
    <InfoTooltip.StyledContent className="!p-2 text-center">
      Total number of editions
      <br />
      minted in primary sale
      <br />
      and Sound Swap.{SPACE}
      <LearnMoreAboutSamLink />
    </InfoTooltip.StyledContent>
  );
};

export const SoundSwapCurrentSupplyInfo = () => {
  return (
    <InfoTooltip.StyledContent className="!p-2 text-center">
      Active circulation of editions,
      <br />
      net of sales.{SPACE}
      <LearnMoreAboutSamLink />
    </InfoTooltip.StyledContent>
  );
};

export const SoundSwapTotalVolumeInfo = () => {
  return (
    <InfoTooltip.StyledContent className="!p-2 text-center">
      Total ETH generated from
      <br />
      editions minted.{SPACE}
      <LearnMoreAboutSamLink />
    </InfoTooltip.StyledContent>
  );
};

export const TotalPriceInfo = ({ variant }: { variant: 'sell' | 'buy' }) => {
  return (
    <InfoTooltip.StyledContent className="!p-2 text-center">
      Price {variant === 'buy' ? 'increases' : 'decreases'} as editions are{' '}
      {variant === 'buy' ? 'collected' : 'sold'}.
      <br />
      <LearnMoreAboutSamLink />
    </InfoTooltip.StyledContent>
  );
};

export const CollectingFrozenInfo = () => {
  return (
    <InfoTooltip.StyledContent className="!p-2 text-center">
      The artist has opted to freeze the
      <br />
      supply of editions.{SPACE}
      <LearnMoreAboutSamLink />
    </InfoTooltip.StyledContent>
  );
};

export const NoLiquidityInfo = () => {
  return (
    <InfoTooltip.StyledContent className="!p-2 text-center">
      There isn't enough liquidity to
      <br />
      sell any editions.{SPACE}
      <LearnMoreAboutSamLink />
    </InfoTooltip.StyledContent>
  );
};

export const MaxThresholdReachedInfo = ({ maxAmount }: { maxAmount: number }) => {
  return (
    <InfoTooltip.StyledContent className="!p-2 text-center">
      There is only enough liquidity
      <br />
      to sell {maxAmount} editions.{SPACE}
      <LearnMoreAboutSamLink />
    </InfoTooltip.StyledContent>
  );
};

export const NoEditionsToSellInfo = () => {
  return (
    <InfoTooltip.StyledContent className="!p-2 text-center">
      You don't own any editions
      <br />
      in your wallet. Collect one first.
    </InfoTooltip.StyledContent>
  );
};

export const CannotSellGoldenEggInfo = () => {
  return (
    <InfoTooltip.StyledContent className="!p-2 text-center">
      The golden egg is quite special and
      <br />
      cannot be sold on Sound Swap.
      <br />
      You can list it on{SPACE}
      <StyledLink absoluteUri={SOUND_MARKET_PLACE_URL} type="external">
        Sound Market
      </StyledLink>
    </InfoTooltip.StyledContent>
  );
};

export const SoundSwapPrimarySupplyInfo = () => {
  return (
    <InfoTooltip.StyledContent className="!p-2 text-center">
      Total number of editions
      <br />
      minted in the primary
      <br />
      sale.
      {SPACE}
      <LearnMoreAboutSamLink />
    </InfoTooltip.StyledContent>
  );
};

const LearnMoreAboutSamLink = () => {
  return (
    <StyledLink absoluteUri={LEARN_MORE_ABOUT_SAM} type="external">
      Learn more
    </StyledLink>
  );
};

const StyledLink = styled(AccessibleLink, {
  textDecoration: 'underline',
});
